import { Component, OnInit } from '@angular/core';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { QuickQuoteService } from '../../../services/quote/quick-quote.service';
import { CoverpathControllerInterface } from '../../../../../../coverpath-common/angular/interfaces/controller/CoverpathControllerInterface';
import { QuoteCardService } from './quote-card.service';
import { AuthenticationService } from '../../../../../../coverpath-common/angular/services/authentication/authentication.service';
import { QuoteCardComponent } from './quote-card.component';

@Component({
  moduleId: module.id,
  selector: 'quote-card-conversion',
  templateUrl: './quote-card-conversion.component.html',
})
export class QuoteCardConversionComponent extends QuoteCardComponent implements OnInit {
  protected controller: CoverpathControllerInterface;
  greeting: string = `Your financial professional started your life insurance conversion application.`;
  premiumLabel: string = `Premium`;

  constructor(
    amorphicService: AmorphicService,
    quickQuoteService: QuickQuoteService,
    quoteCardService: QuoteCardService,
    authenticationService: AuthenticationService
  ) {
    super(amorphicService, quickQuoteService, quoteCardService, authenticationService);
    this.controller = amorphicService.controller;
  }
}
